// Deadline types for frontend

export enum DeadlinePriority {
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low',
}

export enum DeadlineSource {
  SELF_CREATED = 'self_created',
  UNIVERSITY_DEADLINE = 'university_deadline',
  DEMONSTRATED_INTEREST = 'demonstrated_interest',
  COUNSELOR_SHARED = 'counselor_shared',
}

export interface Deadline {
  id: number;
  user_id: string;
  title: string;
  info?: string | null;
  priority: DeadlinePriority;
  due_date: string; // ISO datetime string
  expected_hours?: number | null;
  source_type: DeadlineSource;
  university_id?: number | null;
  completed: boolean;
  created_at: string;
  updated_at: string;
}

export interface DeadlineCreate {
  title: string;
  info?: string;
  priority?: DeadlinePriority;
  due_date: string; // ISO datetime string
  expected_hours?: number;
  source_type?: DeadlineSource;
  university_id?: number;
}

export interface DeadlineUpdate {
  title?: string;
  info?: string;
  priority?: DeadlinePriority;
  due_date?: string;
  expected_hours?: number;
  university_id?: number;
  completed?: boolean;
}

export interface DeadlineFilters {
  priority?: DeadlinePriority;
  source_type?: DeadlineSource;
  completed?: boolean;
  start_date?: string;
  end_date?: string;
}

export interface DeadlineListResponse {
  deadlines: Deadline[];
  total: number;
}

// Helper type for priority badge colors
export const PriorityColors = {
  [DeadlinePriority.HIGH]: {
    bg: 'bg-red-100 dark:bg-red-900/30',
    text: 'text-red-800 dark:text-red-300',
    border: 'border-red-300 dark:border-red-700',
  },
  [DeadlinePriority.MEDIUM]: {
    bg: 'bg-yellow-100 dark:bg-yellow-900/30',
    text: 'text-yellow-800 dark:text-yellow-300',
    border: 'border-yellow-300 dark:border-yellow-700',
  },
  [DeadlinePriority.LOW]: {
    bg: 'bg-green-100 dark:bg-green-900/30',
    text: 'text-green-800 dark:text-green-300',
    border: 'border-green-300 dark:border-green-700',
  },
} as const;

// Helper function to format priority for display
export const formatPriority = (priority: DeadlinePriority): string => {
  return priority.charAt(0).toUpperCase() + priority.slice(1);
};

// Helper function to format source type for display
export const formatSourceType = (source: DeadlineSource): string => {
  return source
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
